(function () {

    angular
        .module('smartertoolsApp')
        .factory('invoices', ['$http', 'refreshToken', '$q', invoicesFactory]);

    function invoicesFactory($http, refreshToken, $q) {
        var urlBase = apiRootUrl;
        var invoicesPromise;

        return {
            getInvoices: getInvoices,
            downloadPdf: downloadPdf,
            sendInvoiceEmail: sendInvoiceEmail,
            payExistingCard: payExistingCard,
            payNewCard: payNewCard
        };

        // -----------------------------------------------

        function getInvoices() {
            if (invoicesPromise)
                return invoicesPromise;
            invoicesPromise = refreshToken.refreshToken()
                .then(() => $http.get(`${urlBase}v1/account/invoices/all`))
                .then((response) => {
                    invoicesPromise = null;
                    return response.data.Invoices;
                })
                .catch((err) => {
                    invoicesPromise = null;
                    $q.reject(err);
                });
            return invoicesPromise;
        }

        function downloadPdf(invoiceNumber) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${urlBase}v1/account/invoices/generate-pdf`, JSON.stringify({ InvoiceNumber: invoiceNumber })))
                .then((response) => response.data);
        }

        function sendInvoiceEmail(invoiceNumber, emailAddress) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${urlBase}v1/account/invoices/send-email`,
                    JSON.stringify({ InvoiceNumber: invoiceNumber, EmailAddress: emailAddress })))
                .then((response) => response.data);
        }

        function payExistingCard(invoiceNumber, paymentMethod) {
            return refreshToken.refreshToken()
                .then(() => $http.post(urlBase + 'v1/account/invoices/pay-existing-card',
                    JSON.stringify({
                        InvoiceNumber: invoiceNumber,
                        PaymentMethodId: paymentMethod.PaymentMethodId,
                        SecurityCode: paymentMethod.SecurityCode
                    })))
                .then((response) => response.data);
        }

        function payNewCard(invoiceNumber, paymentMethod) {
            return refreshToken.refreshToken()
                .then(() => $http.post(urlBase + 'v1/account/invoices/pay-new-card',
                    JSON.stringify({
                        InvoiceNumber: invoiceNumber,
                        CardNumber: paymentMethod.CardNumber,
                        NameOnCard: paymentMethod.NameOnCard,
                        ExpirationMonth: paymentMethod.ExpirationMonth,
                        ExpirationYear: paymentMethod.ExpirationYear,
                        SecurityCode: paymentMethod.SecurityCode,
                        Country: paymentMethod.Country,
                        Address1: paymentMethod.Address1,
                        Address2: paymentMethod.Address2,
                        City: paymentMethod.City,
                        State: paymentMethod.State,
                        ZipCode: paymentMethod.ZipCode,
                        SaveCard: paymentMethod.SaveCard
                    })))
                .then((response) => response.data);
        }
    }

})();